import { slices } from "@/constants/sliceNames";
import store from "../store/store";

// PLEASE DON'T EDIT THIS FROM HERE, USE .env FILE INSTEAD
export const HOSTNAME = process.env.REACT_APP_HOSTNAME ?? window?.location?.hostname;

export const buildSocketUrl = (endpoint = "ws") => {
  let hostname = HOSTNAME;

  let protocol = "wss";

  if (hostname.includes("localhost")) {
    protocol = "ws";
  }

  const userToken = store.getState()[slices.auth].userToken;

  return `${protocol}://${hostname}/${endpoint}?token=${userToken}`;
};
